//https://codepen.io/nikhil8krishnan/pen/rVoXJa
export const SpinnerIcon = ({ opacity = '1', color = '#009FB7' }) => {
    return (
        <svg 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 100 100" 
        enableBackground="new 0 0 0 0">
        <circle fill="none" stroke={color} strokeWidth="4" cx="50" cy="50" r="44" opacity={opacity}/>
        <circle fill="#fff" stroke="rgba(0,0,0,0)" strokeWidth="3" cx="8" cy="54" r="6" >
            <animateTransform
            attributeName="transform"
            dur="4s"
            type="rotate"
            from="0 50 48"
            to="360 50 52"
            repeatCount="indefinite" />
        </circle>
        </svg>
    );
}